/* eslint-disable react/react-in-jsx-scope */
import Creative from '../../img/Creative Photography.png'
import Polygon from '../../img/Polygon 5.png'
import Planet from '../../img/планета (2).png'

import './style.css'

const InfoSchool = () => {
  return (
    <>
      <section className="about center">
        <div className="about-cont">
          <h1 className="about-us">О НАС</h1> 
{/* исправить высоту */}
          <img className="about-img" src={Creative} alt="" />
        </div>{' '}
        <div className="about-box">
          <p className="about-box-txt">
            Мы получили образование в&nbsp;нескольких киношколах и&nbsp;пришли
            к&nbsp;выводу, что&nbsp;многие важные темы остаются нераскрытыми
            в&nbsp;процессе обучения. Вот&nbsp;тогда у&nbsp;нас и&nbsp;возникла
            идея создания киношколы{' '}
            <span className="yellow-span">
              с&nbsp;детальным подходом к&nbsp;образованию
            </span>
            .
          </p>
          <p className="about-box-txt">
            Кроме того, в большинстве случаев студенты, получив диплом,
            не&nbsp;имели четкого представления о&nbsp;том,{' '}
            <span className="yellow-span">
              как&nbsp;развивать свою карьеру в&nbsp;киноиндустрии
            </span>
            . Мы&nbsp;начали анализ качества кинообразования и&nbsp;приступили
            к&nbsp;работе над&nbsp;получением образовательной лицензии.
          </p>
          <p className="about-box-txt">
            И в 2023 году получили лицензию, укрепив наши позиции в&nbsp;сфере
            кинообразования.{' '}
            <span className="yellow-span">FREE SUN FILM SCHOOL</span> привлекла
            к&nbsp;работе практикующих профессионалов киноиндустрии, которые
            разработали{' '}
            <span className="yellow-span">уникальные авторские курсы</span>.
          </p>
        </div>
      </section>
      <img className="polygon center-footer" src={Polygon} alt="" />

      <section className="philosophy center">
        <h2 className="philosophy-title">
          ФИЛОСОФИЯ <br />
          <span className="yellow-span">FREE SUN FILM SCHOOL</span>{' '}
        </h2>
        <div className="philosophy-box">
          <p className="philosophy-box-txt">
            <span className="yellow-span">Free Sun Film School</span> создает
            актуальные образовательные программы, сопровождая студентов
            на&nbsp;пути в&nbsp;
            <span className="yellow-span">профессиональное киносообщество</span>
            .
          </p>
        </div>
      </section>
      <section className="center">
        <div className="philosophy-content">
          <div className="philosophy-content-box">
            <div className="philosophy-num">
              <p className="philosophy-num-txt">1</p>
            </div>
            <div className="philosophy-content-wrap">
              <h3 className="philosophy-content-title">
                Детальность и практичность
              </h3>
              <p className="philosophy-content-txt">
                Мы предлагаем тщательно проработанные{' '}
                <span className="yellow-span">авторские программы</span>,
                которые глубоко раскрывают все аспекты кинопроизводства
                и&nbsp;основаны на&nbsp;актуальных запросах киноиндустрии.
                Каждая&nbsp;новая тема закрепляется путем выполнения
                практических заданий, позволяя{' '}
                <span className="yellow-span">выработать навык</span>
                &nbsp;и&nbsp;
                <span className="yellow-span">
                  усовершенствовать мастерство
                </span>
                .
              </p>
            </div>
          </div>
          <div className="philosophy-content-box philosophy-content-box-bg philosophy-content-box-mob">
            <div className="philosophy-num">
              <p className="philosophy-num-txt">2</p>
            </div>
            <div className="philosophy-content-wrap">
              <h3 className="philosophy-content-title">
                Индивидуальный подход
              </h3>
              <p className="philosophy-content-txt">
                Каждому студенту предоставляется персональное внимание
                и&nbsp;поддержка. Мы&nbsp;адаптируем образовательный процесс
                под&nbsp;ваш опыт, обеспечивая максимально эффективное и&nbsp;
                <span className="yellow-span">комфортное обучение</span>.
              </p>
            </div>
          </div>
          <div className="philosophy-content-box philosophy-content-box-bg ">
            <div className="philosophy-num">
              <p className="philosophy-num-txt">3</p>
            </div>
            <div className="philosophy-content-wrap">
              <h3 className="philosophy-content-title">Уникальность</h3>
              <p className="philosophy-content-txt">
                Наши курсы разработаны действующими профессионалами
                киноиндустрии и включают самые практичные методики.
                Вы&nbsp;получите{' '}
                <span className="yellow-span">
                  доступ к&nbsp;эксклюзивным материалам
                </span>{' '}
                и&nbsp;инсайтам, недоступным в&nbsp;других учебных заведениях.
              </p>
            </div>
          </div>

          <div className="philosophy-content-box philosophy-content-box-mob">
            <div className="philosophy-num">
              <p className="philosophy-num-txt">4</p>
            </div>
            <div className="philosophy-content-wrap">
              <h3 className="philosophy-content-title">
                Карьерное сопровождение и&nbsp;менеджмент
              </h3>
              <p className="philosophy-content-txt">
                Мы поддерживаем ваше профессиональное развитие даже после
                прохождения обучения в&nbsp;нашей киношколе, предоставляя
                консультации и&nbsp;помощь. Программа&nbsp;
                <span className="yellow-span">«Золотой&nbsp;бонус»</span>{' '}
                обеспечивает лучшим студентам{' '}
                <span className="yellow-span">
                  уникальные возможности для продвижения
                </span>{' '}
                и&nbsp;создания успешной карьеры в&nbsp;киноиндустрии.
              </p>
            </div>
          </div>
          <div className="philosophy-content-box ">
            <div className="philosophy-num">
              <p className="philosophy-num-txt">5</p>
            </div>
            <div className="philosophy-content-wrap">
              <h3 className="philosophy-content-title">
                Профессиональное сообщество и&nbsp;нетворкинг
              </h3>
              <p className="philosophy-content-txt">
                Обучаясь у нас,{' '}
                <span className="yellow-span">вы становитесь частью</span>{' '}
                активного профессионального{' '}
                <span className="yellow-span">киносообщества</span>.
                Мы&nbsp;организуем мастер-классы, семинары и&nbsp;мероприятия,
                способствующие обмену опытом и&nbsp;установлению ценных
                контактов в&nbsp;киноиндустрии.
              </p>
            </div>
          </div>
        </div>
      </section>
      <img className="polygon center-footer" src={Polygon} alt="" />

      <section className="concept center">
        <div className="concept-box">
          <div className="concept-content">
            <h2 className="concept-title">КОНЦЕПЦИЯ ОБРАЗОВАНИЯ</h2>
            <p className="concept-txt">
              Концепция образования{' '}
              <span className="yellow-span">Free Sun Film School</span>{' '}
              заключается в&nbsp;том, что&nbsp;каждая кинопрофессия
              рассматривается как&nbsp;большая планета, а&nbsp;
              <span className="yellow-span">
                каждый курс — как&nbsp;пиксель
              </span>
              , постепенно наполняющий и&nbsp;раскрывающий все аспекты
              этой&nbsp;профессии, будь то режиссура, сценарное мастерство,
              актерское мастерство, продюсирование и&nbsp;другое.
            </p>
          </div>

          <div className="concept-wrap">
            <img className="concept-wrap-img" src={Planet} alt="" />
            <p className="concept-wrap-txt concept-wrap-txt-1">
              Режиссура рекламы
            </p>
            <p className="concept-wrap-txt concept-wrap-txt-2">
              Планета Режиссура Кино
            </p>
            <p className="concept-wrap-txt concept-wrap-txt-3">
              Работа режиссера с актером
            </p>
            <p className="concept-wrap-txt concept-wrap-txt-4">Киножанры</p>
          </div>
        </div>
      </section>
      <img className="polygon center-footer" src={Polygon} alt="" />
    </>
  )
}

export default InfoSchool
